export class Billing {
    ShipperAccountNumber: any; 
    ShippingPaymentType: any; 
    BillingAccountNumber: any;  
} 
 